import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { trainingApi } from '../../services';
import { utitService } from '../../services/util';
import { Rating } from 'primereact/rating';
import { Dialog } from 'primereact/dialog';
import { toast } from "react-toastify";
import { skillService } from "../../services/profile";

const UserRatingDetailView = ({ clickedRowData }) => {
    const [userSkillList, setUserSkillList] = useState([]);
    const [updateRatingDialog, setUpdateRatingDialog] = useState(false);
    const [clickedSkillRecord, setClickedSkillRecord] = useState({});
    const [updatedRating, setUpdatedRating] = useState(0);
    useEffect(() => {
        getUserSkill();
    }, []);

    const getUserSkill = () => {
        trainingApi.fetchSkillsByID(clickedRowData?.id).then((resp) => {
            try {
                setUserSkillList(resp.data.data);
            } catch (error) {
                // Error handle
            }
        });
    };


    const skillNameBody = (rowData) => {
        return rowData?.Skill?.title;
    }

    const editActionBody = (rowData) => {
        return (<>
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" severity="secondary" onClick={() => updateUserSkillRating(rowData)} />
        </>)
    }

    const updateUserSkillRating = (rowData) => {
        setClickedSkillRecord(rowData);
        setUpdateRatingDialog(true);
    }

    const saveUserSkillRating = () => {
        let param = {
            id: clickedSkillRecord?.id,
            primarySkillRating: updatedRating,
            userId: clickedSkillRecord?.userId,
        };
        try {
            skillService.updateSkill(param).then((resp) => {
                if (resp) {
                    toast.success("Skill Rating Updated");
                    setUpdatedRating(0);
                    setUpdateRatingDialog(false);
                    getUserSkill();
                }

            });
        } catch (error) {
            console.log(error);
        }
    }

    const renderUpdateUserSkillDialog = () => {
        return (<>
            <Dialog header="Update User Skill Rating" visible={updateRatingDialog} onHide={() => setUpdateRatingDialog(false)} style={{ width: '30vw' }}>
                <hr />
                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                            Skill Name : 
                        </label>
                        {clickedSkillRecord?.Skill?.title}
                    </div>

                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                            Current Rating
                        </label>
                        <Rating value={clickedSkillRecord?.primarySkillRating} cancel={false} readOnly />
                    </div>
                </div>
                {/* <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                            Current Rating
                        </label>
                        <Rating value={clickedSkillRecord?.primarySkillRating} />
                    </div>
                </div> */}
                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">
                            Update Rating
                        </label>
                        <Rating value={updatedRating} onChange={(e) => setUpdatedRating(e.target.value)} cancel={false} />
                    </div>


                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    <Button label='Submit' icon='pi pi-save' severity='primary' className='mr-1' style={{width: "auto"}} onClick={saveUserSkillRating} />
                    <Button label='Cancel' type='button' icon='pi pi-times' severity='secondary' style={{width: "auto"}} onClick={() => setUpdateRatingDialog(false)} />
                </div>
            </Dialog>
        </>)
    }

    const userSkillRatingBody = (rowData) => {
        return (
            <Rating value={rowData?.primarySkillRating} cancel={false} readOnly />
        )

    }

    return (
        <>
            <DataTable value={userSkillList} stripedRows responsiveLayout="scroll"
                paginator
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
            >
                <Column field="" header="Skill" body={skillNameBody} ></Column>
                <Column field="" header="Rating" body={userSkillRatingBody} />
                <Column field="Designation" header="Created On" body={(r) => (utitService.dateWithMonthConverter(r.createdAt))}></Column>
                <Column field="createdAt" header="Updated On" body={(r) => (utitService.dateWithMonthConverter(r.updatedAt))}></Column>
                <Column field='' header="Action" body={editActionBody} />
            </DataTable>
            {renderUpdateUserSkillDialog()}
        </>
    )
}

export default UserRatingDetailView;